import React, { useState } from 'react'
import { Panel, EditSaveCancelButtons, useIsEditing } from './blocks'
import { cn } from '~/lib/utils'
import { CheckIcon } from '@heroicons/react/24/outline'
import { useProfileMutation } from './QueryClient'

const availableStrengths = [
  'Client Advocate',
  'Calm in Chaos',
  'Data-Driven',
  'Adoption Coach',
  'Clear & Direct',
  'Thoughtful Listener',
  'Empathy-Driven',
  'Bridge Builder',
  'Global Mindset',
  'Product Expert',
  'Process Pro',
  'Quick to Respond',
  'Insights Focused',
  'Feedback Friendly',
  'ROI Focused',
  'Solution Crafter',
]

const KeyStrengths = ({ selectedStrengths }) => {
  const [updatedStrengths, setUpdatedStrengths] = useState(
    selectedStrengths || [],
  )
  const profileMutation = useProfileMutation()

  const strengthsChanged =
    JSON.stringify(updatedStrengths) !== JSON.stringify(selectedStrengths || [])

  const toggleSelection = (strength) => () => {
    if (updatedStrengths.includes(strength)) {
      setUpdatedStrengths(updatedStrengths.filter((s) => s !== strength))
    } else {
      if (updatedStrengths.length < 4) {
        setUpdatedStrengths([...updatedStrengths, strength])
      }
    }
  }

  const saveClick = () => {
    strengthsChanged
      ? profileMutation.mutate({ key_strengths: updatedStrengths })
      : cancelClick()
  }

  const cancelClick = () => {
    setUpdatedStrengths(selectedStrengths || [])
  }

  return (
    <Panel>
      <div className="flex flex-col">
        <div className="flex w-full flex-row justify-between">
          <div className="text-lg font-medium tracking-wide text-intoo-text">
            Basic Information
          </div>
          <EditSaveCancelButtons
            sectionName="Strengths"
            saveClick={saveClick}
            cancelClick={cancelClick}
          />
        </div>
        <div>
          Select up to 4 strengths that best describe you
          <span className="ml-1 text-intoo-blue-medium">
            ({updatedStrengths.length}/4 selected)
          </span>
        </div>
      </div>
      <div className="flex flex-row flex-wrap gap-4">
        {availableStrengths.map((strength) => (
          <StrengthOption
            key={strength}
            strength={strength}
            isSelected={updatedStrengths.includes(strength)}
            onClick={toggleSelection(strength)}
          />
        ))}
      </div>
    </Panel>
  )
}

const StrengthOption = ({ strength, isSelected, onClick }) => {
  const baseClass =
    'cursor-pointer rounded-full border px-4 py-2 transition-colors'
  const selectedClass = 'bg-intoo-blue-medium text-white'
  const unselectedClass =
    'text-intoo-text hover:bg-intoo-blue-light border-black/10 bg-white'
  const stateClass = isSelected ? selectedClass : unselectedClass
  const className = cn(stateClass, baseClass)
  const { isEditing } = useIsEditing()

  return (
    <button onClick={onClick} className={className} disabled={!isEditing}>
      {isSelected && (
        <CheckIcon className="mr-2 inline-block size-4 stroke-2" />
      )}
      {strength}
    </button>
  )
}
export default KeyStrengths
